import type { Failure } from '@/core/lib/result'
import { getDocBucketAddress } from '@/core/data/dokumente'
import { setAufgabe, type AdvanceResult } from '@/core/data/coachings'
import { renderBescheinigung } from '../lib/renderBescheinigung'

const ANWESENHEITSLISTE = 'anwesenheitsliste'

export async function getAnwesenheitslistePath(coachingId: string): Promise<string | null> {
  return getDocBucketAddress(coachingId, ANWESENHEITSLISTE)
}

export async function confirmTeilnehmendenliste(coachingId: string): Promise<AdvanceResult | Failure> {
  const rendered = await renderBescheinigung(coachingId)
  if (!rendered.ok) return rendered
  return setAufgabe(coachingId, 'zertifikatPruefen')
}
